import { TimeService_timeServiceGetGetTime } from '@festina/unitlink-general-types/unitlink-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchUnitlinkTimeNoSuspense =
  TimeService_timeServiceGetGetTime.useQuery
